import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { cn } from "@nxt-shared/ui/lib/utils";
const SIZE = {
    lg: "size-16 rounded-lg text-2xl",
    md: "size-7 rounded-md text-sm",
    sm: "size-5 rounded-sm text-xs",
    xs: "size-4 rounded-sm text-xs",
};
/**
 * The Organization's mark: its image when the listing supplies one that loads, otherwise a letter
 * placeholder derived from the display name.
 */
export function OrgMark({ name, imageUrl, size = "md", className, }) {
    const [failedUrl, setFailedUrl] = useState();
    if (imageUrl && imageUrl !== failedUrl) {
        return (_jsx("img", { src: imageUrl, alt: "", onError: () => setFailedUrl(imageUrl), className: cn("shrink-0 object-cover", SIZE[size], className) }));
    }
    const letter = name.trim().charAt(0).toUpperCase() || "?";
    return (_jsx("span", { "aria-hidden": true, className: cn("inline-flex shrink-0 items-center justify-center bg-[color-mix(in_oklab,var(--secondary)_10%,var(--popover))] font-bold text-secondary-darkest select-none", SIZE[size], className), children: letter }));
}
//# sourceMappingURL=OrgMark.js.map